// extracted by mini-css-extract-plugin
export var inline = "_v7-0";